import { validateMaxLength } from 'hb-react/shared/utils/validators/maxLength';
import { validateMinLength } from 'hb-react/shared/utils/validators/minLength';
import { validateRegex } from 'hb-react/shared/utils/validators/regex';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const mustBeValidErrorMessage = s__(
  'InputValidation|Must be a valid phone number with only numbers, spaces, +, -, ( and )',
);

export const validateTelephone = ({
  maxLength,
  minLength,
  required,
  value,
}) => {
  let error;

  maxLength ??= 15;
  minLength ??= 7;

  if (required) {
    error = validateRequired(value);
  }

  if (maxLength && !error) {
    error = validateMaxLength(value, maxLength);
  }

  if (minLength && !error) {
    error = validateMinLength(value, minLength);
  }

  if (!error) {
    error = validateRegex(value, /^[+()-\d ]+$/, mustBeValidErrorMessage);
  }

  return error;
};
